import{css}from"@primeuix/styled";var style=css`
    .p-checkbox-group {
        display: inline-flex;
    }
`;export{style};//# sourceMappingURL=index.mjs.map